import React from "react";
import styles from "./outlinedButton.module.scss";
import { Button } from "@mui/material";

const OutlinedButton = ({
  title,
  txtClr,
  bgclr,
  fontSize,
  startIcon,
  fontWeight,
  // width,
  height,
  borderRadius,
  border,
  endIcon,
  // maxwidth,
  // minwidth,
  padding,
  onclick = Function,
}) => {
  return (
    <div className={styles.container}>
      <Button
        variant="outlined"
        startIcon={startIcon}
        endIcon={endIcon}
        style={{
          fontSize: fontSize,
          color: txtClr,
          backgroundColor: bgclr,
          fontWeight: fontWeight,
          // maxwidth: maxwidth,
          // minwidth: minwidth,
          // width: "100%",
          height: height,
          borderRadius: borderRadius,
          border: border,
          padding: padding,
        }}
        onClick={onclick}
      >
        {title}
      </Button>
    </div>
  );
};

export default OutlinedButton;
